import contactsService from '../../api/contacts'
const state = {
  contacts: []
}

const mutations = {
  setContacts (state, contacts) {
    state.contacts = contacts
  }
}

const actions = {
  getContacts ({ commit }) {
    return new Promise((resolve, reject) => {
      contactsService.getContacts().then((res) => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
